/**
 * @generated SignedSource<<b19aa5f8725360b2116dec1af4aa79bd>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PhotoHeading_photo$data = {
  readonly project: {
    readonly projectTypes: ReadonlyArray<string | null> | null;
  } | null;
  readonly room: {
    readonly name: string | null;
  } | null;
  readonly styles: ReadonlyArray<{
    readonly name: string | null;
    readonly urlLabel: string | null;
  } | null> | null;
  readonly " $fragmentType": "PhotoHeading_photo";
};
export type PhotoHeading_photo$key = {
  readonly " $data"?: PhotoHeading_photo$data;
  readonly " $fragmentSpreads": FragmentRefs<"PhotoHeading_photo">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PhotoHeading_photo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TradePhotoStyle",
      "kind": "LinkedField",
      "name": "styles",
      "plural": true,
      "selections": [
        (v0/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "urlLabel",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TradePhotoStyle",
      "kind": "LinkedField",
      "name": "room",
      "plural": false,
      "selections": [
        (v0/*:: as any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PhotosSearchBrowsePhotoProject",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "projectTypes",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PhotosSearchBrowsePhoto",
  "abstractKey": null
};
})();

(node as any).hash = "e5050d6fd7ce18419456fb37432ebc66";

export default node;
